module.exports = "#define GLSLIFY 1\nuniform float cycleColors;\n\nvarying float vAlpha;\nvarying float vUpdated;\n\nvoid main(){\n\n  vec3 color = vec3(1.);\n\n  /*if (cycleColors == 1.0) {\n    if (vUpdated > 1.) {\n      float amount = min(1., vUpdated - 1.);\n      color = mix(vec3(.09, .274, .627), vec3(.7, .7, .7), amount);\n    } else {\n      color = mix(vec3(0.921, 0.133, 0.337), vec3(.09, .274, .627), vUpdated);\n    }\n  }*/\n\n  float a = vAlpha;\n\n  gl_FragColor = vec4(color, a);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/libs/geometry/edge/shaders/edge.frag
// module id = 438
// module chunks = 0